import React, {useCallback, useEffect} from 'react';
import {EditorContent, useEditor} from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Placeholder from '@tiptap/extension-placeholder';
import Link from '@tiptap/extension-link';
import {Bold, Italic, Link2, Link2Off, Underline as UnderlineIcon} from 'lucide-react'; // You can use any icon lib
import "./TipTapEditor.scss";

const TipTapEditor = ({value, onChange}: any) => {
    const editor = useEditor({
        extensions: [
            StarterKit,
            Underline,
            Placeholder.configure({
                placeholder: 'Write your update here...',
            }),
            Link.configure({
                openOnClick: false,
            }),
        ],
        content: value,
        onUpdate: ({editor}) => {
            onChange(editor.getHTML());
        },
    });
    useEffect(() => {
        if (editor && value !== editor.getHTML()) {
            editor.commands.setContent(value);
        }
    }, [value]);
    const setLink = useCallback(() => {
        if (!editor) return null;
        const previousUrl = editor.getAttributes('link').href
        const url = window.prompt('URL', previousUrl)

        // cancelled
        if (url === null) {
            return
        }

        // empty
        if (url === '') {
            editor.chain().focus().extendMarkRange('link').unsetLink()
                .run()

            return
        }

        // update link
        try {
            editor.chain().focus().extendMarkRange('link').setLink({ href: url })
                .run()
        } catch (e: any) {
            alert(e.message)
        }
    }, [editor])

    if (!editor) return null;

    return (
        <div className="space-y-2">
            {/* Toolbar */}
            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleBold().run()}
                    className={`editor-btn ${editor.isActive('bold') ? 'active' : ''}`}
                    title="Bold"
                >
                    <Bold size={14}/>
                </button>

                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleItalic().run()}
                    className={`editor-btn ${editor.isActive('italic') ? 'active' : ''}`}
                    title="Italic"
                >
                    <Italic size={14}/>
                </button>

                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleUnderline().run()}
                    className={`editor-btn ${editor.isActive('underline') ? 'active' : ''}`}
                    title="Underline"
                >
                    <UnderlineIcon size={14}/>
                </button>
                <button
                    type="button"
                    onClick={setLink}
                    className={`editor-btn ${editor.isActive('link') ? 'is-active' : ''}`}
                    title="Link"
                >
                    <Link2 size={14}/>
                </button>
                {/*<button*/}
                {/*    type="button"*/}
                {/*    onClick={() => editor.chain().focus().unsetLink().run()}*/}
                {/*    title="UnLink"*/}
                {/*    className={`editor-btn`}*/}
                {/*    style={!editor.isActive('link') ?  {color: 'darkgray'} : {}}*/}
                {/*    disabled={!editor.isActive('link')}*/}
                {/*>*/}
                {/*    <Link2Off size={14}/>*/}

                {/*</button>*/}
            </div>

            {/* Editor */}
            <div
                className="custom-editor-scroll"
                style={{
                    padding: '0.5rem',
                    overflowY: 'auto',
                    maxHeight: '230px',
                }}
            >
                <EditorContent editor={editor}/>
            </div>
        </div>
    );
};

export default TipTapEditor;
